import {Component, inject, PLATFORM_ID} from '@angular/core';
import {FormControl, FormGroup, Validators, ReactiveFormsModule} from "@angular/forms";
import {MinizaemApiClientService} from "../../services/minizaem-api-client.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {SharedStateService} from "../../services/shared-state.service";
import {CustomerService} from "../../../customer/services/customer.service";
import {Router, RouterLink} from '@angular/router';
import {FormElementComponent} from '../form-element/form-element.component';
import {MenuComponent} from '../menu/menu.component';
import {LoanService} from "../../../loan/services/loan.service";
import {LoanApplicationService} from "../../../loan/services/loan-application.service";
import {Loader} from "../loader/loader";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    RouterLink,
    ReactiveFormsModule,
    FormElementComponent,
    MenuComponent,
    Loader,
  ],
})

export class HeaderComponent {
  protected minizaemApiClient = inject(MinizaemApiClientService);
  protected customerService = inject(CustomerService);
  protected loanService = inject(LoanService);
  protected loanApplicationService = inject(LoanApplicationService);
  protected router: Router = inject(Router);
  protected snackBar = inject(MatSnackBar);
  protected sharedState = inject(SharedStateService);
  protected isCustomerPanelLoading = false;
  protected platformId = inject(PLATFORM_ID);

  loginForm = new FormGroup({
    email: new FormControl('', [
      Validators.required,
      Validators.email,
    ]),
    password: new FormControl('', [
      Validators.required,
    ]),
  });

  login(): void {
    this.loginForm.markAllAsTouched();
    if (this.loginForm.valid) {
      const email = this.loginForm.get('email')?.value ?? '';
      const password = this.loginForm.get('password')?.value ?? '';
      this.isCustomerPanelLoading = true;

      // const email = !isNull(this.loginForm.get('email')) ? this.loginForm.get('email').value : "";
      this.minizaemApiClient.refreshToken(email, password).subscribe({
          next: resultJson => {
            if (resultJson.jwt === null) {
              this.showLoginErrorMessage();
            } else {
              this.minizaemApiClient.setJwt(resultJson.jwt);
              const jwtPayload = this.minizaemApiClient.getJwtPayload();

              if (jwtPayload) {
                this.customerService.getFromApi().subscribe(
                  {
                    next: result => {
                      this.customerService.setToStorage(result);
                      this.loanService.showCurrentForCustomer().subscribe(
                        {
                          next: result => {
                            this.sharedState.customerCurrentLoan.set(result);
                            if (result) {
                              this.router.navigateByUrl("/customer/profile");
                            } else {
                              this.router.navigateByUrl("/");
                            }
                          }
                        }
                      );
                      this.loanApplicationService.removeAllApplicationStepsFromStorage();
                      this.isCustomerPanelLoading = false;
                    }
                  }
                );
              }
            }
          },
          error: err => {
            this.showLoginErrorMessage();
            this.isCustomerPanelLoading = false;
          },
        }
      );
    }
  }

  logout(): void {
    this.customerService.logout();
    this.loanApplicationService.removeAllApplicationStepsFromStorage();
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = "/";
    } else {
      this.router.navigateByUrl("/");
    }
  }

  showLoginErrorMessage(): void {
    this.snackBar.open('Грешно потребителско име или парола!', '×', {
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: 'error',
    });
  }

}
